@if (user) {
  <div fxLayout="column" fxLayoutGap="20px" fxFlexFill class="user-info">
    <div fxLayout="column" class="user-details">
      <div fxLayout="row" fxLayoutAlign="space-between center" class="header-row">
        <span class="header">{{ "profile.title" | translate }}</span>
        <div fxLayout="row" fxLayoutAlign="end center" class="right-controls">
          @if (supportedLangs.length > 1 ) {
            <button mat-button [matMenuTriggerFor]="langMenu" class="lang-btn">
              {{ currentLang.label }}
              <mat-icon class="arrow-icon">arrow_drop_down</mat-icon>
            </button>
            <mat-menu #langMenu="matMenu" class="lang-menu">
              @for (lang of supportedLangs; track lang) {
                <button mat-menu-item (click)="switchLang(lang)">
                  {{ lang.label }}
                </button>
              }
            </mat-menu>
          }
          <div class="theme-toggle">
            <button
              mat-icon-button
              (click)="toggleTheme()"
              [matTooltip]="
                currentTheme === 'badger-light' ? 'Dark Theme' : 'Light Theme'
              "
              [matTooltipShowDelay]="600"
            >
              <mat-icon class="theme-toggle-icon">
                {{
                  currentTheme === "badger-light" ? "dark_mode" : "light_mode"
                }}
              </mat-icon>
            </button>
          </div>
        </div>
      </div>
      @if (user) {
        <div #profile fxLayout="column" fxLayoutGap="20px">
          @if (user.firstName && user.lastName) {
            <div #firstName fxLayout="column" fxLayoutGap="5px">
              <span class="label">{{ "profile.name.label" | translate }}</span>
              <span class="info">{{ user.firstName + " " + user.lastName }}</span>
            </div>
          }
          <div #email fxLayout="column" fxLayoutGap="5px">
            <span class="label">{{ "profile.email.label" | translate }}</span>
            <span class="info">{{ user.email }}</span>
          </div>
          <div #organization fxLayout="column" fxLayoutGap="5px">
            <span class="label">{{ "profile.organization.label" | translate }}</span>
            <span class="info">{{ user.organization?.name }}</span>
          </div>
          <div #store fxLayout="column" fxLayoutGap="5px">
            <span class="label">{{ "profile.homeStore.label" | translate }}</span>
            @if (userHomeStore) {
              <span class="info">{{ userHomeStore.clientStoreId }}</span>
              <span class="info">{{ userHomeStore.address }}</span>
              <span class="info">{{ userHomeStore.city + ", " + userHomeStore.state }}</span>
              <span class="info">{{ userHomeStore.phone }}</span>
            } @else {
              <span class="info-disabled">not set</span>
            }
          </div>
          <div #roles fxLayout="column" fxLayoutGap="5px">
            <span class="label">{{ user.roles.length > 1 ? ("profile.role.label" | translate) : ("profile.roles.label" | translate) }}</span>
            @for (role of user.roles; track role) {
              <span class="info">{{ role }}</span>
            }
          </div>
        </div>
      }
    </div>
    <mat-divider></mat-divider>
    <div fxLayout="row" fxLayoutGap="10px" class="user-actions">
      @if (roleOptions?.length > 0) {
        <button *hasAccess="['admin']" mat-stroked-button (click)="openEdit()">
          <mat-icon>edit</mat-icon>
          {{ "general.label.edit" | translate }}
        </button>
      }
      <button mat-stroked-button (click)="signOut()">
        <mat-icon>logout</mat-icon>
        {{ "general.label.signOut" | translate }}
      </button>
    </div>
  </div>
}
